/* Wholesale functionality */
var wholesale_total = 0 ;
var cart_total = 0 ;


console.log( '...' ) ;
var find_jquery_interval = setInterval(function(){
	try {
		if ( $ ) {
			clearInterval( find_jquery_interval ) ;
			initWholesale();
			//initCart();
			initCustomProductsFilter();

			initMobileSidebarReveals() ;
		}
	} catch ( error ) {
		console.log( error ) ;
	}
} , 1000 ) ;





function initMobileSidebarReveals() {
	//console.log( 'initMobileSidebarReveals' ) ;
	$( '.category-heading:not(.no-children)' ).click(function(event){
		//console.log( '.category-heading clicked' ) ;
		event.preventDefault();
		this.classList.toggle( 'opened' ) ;
	})

	$( '.mobile.sidebar > h3' ).click(function(event){
		event.preventDefault();
		this.classList.toggle( 'opened' ) ;
	})
}
















// init the wholesale form functionality //
function initWholesale(){
	$(document).ready(function(){

		$('#wholesale-form input:not([type="submit"])').keypress( function(e) {
		  if( e.which == 13 ) {
		  	e.preventDefault();
		    console.log( 'You pressed enter!' ) ;
		  }
		});

		$('#wholesale-form').change(function(){
			wholesaleFormChangeHandler()
		});

		wholesaleFormChangeHandler();
	});
}


// init the cart form functionality //
function initCart(){
	$(document).ready(function(){

		$('#cart-form input:not([type="submit"])').keypress( function(e) {
		  if( e.which == 13 ) {
		  	e.preventDefault();
		    console.log( 'You pressed enter!' ) ;
		  }
		});

		$('#cart-form').change(function(){
			cartFormChangeHandler()
		});

		cartFormChangeHandler();
	});
}
























function wholesaleFormChangeHandler() {
	wholesale_total = 0 ;
	wholesale_product_total = 0;
	$( '#wholesale-form .product-item' ).each(function(){
	//$('.template-cart.is-wholesaler .product-item').each(function(){
		var quantity = 0 ;
		var price = 0 ;
		var quantity_input = $( this ).find( '.quantity .product-form__input' ) ;
		if ( quantity_input.length > 0 ) quantity = quantity_input[ 0 ].value ;

		var money_span = $( this ).find( '.wholesale-price .money' ) ;
		// convert to camelCase because the html5 data attribute is kinda dumb //
		if ( money_span.length > 0 ) price = money_span[ 0 ].dataset[ 'originalValue' ] ;

		var line_total = 0 ;

		if ( price && quantity ) line_total = price * quantity ;

		wholesale_total += line_total ;
		wholesale_product_total += Number(quantity);
		//console.log( 'line_total: ' , line_total , ' Total: ' , wholesale_total ) ;
	});
	//console.log( 'Setting values to:' , wholesale_total ) ;
	// generate and apply the new html //
	var html_str = '<span id="the-subtotal-price" class="money" data-original-value="' + wholesale_total + '">' + wholesale_total + '</span>' ;
	$('#the-subtotal-price').replaceWith( html_str ) ;
	//$('#the-subtotal-price').fadeIn( 1000 ) ;
	$('#the-subtotal-price').hide().fadeIn('slow') ;
	requestCurrencyUpdate() ;

	/*
	// Devnote 20200108: removed because client wants the discount to apply to ANY number of items, rather than a minimum of 12 as was the case before
	if ( wholesale_product_total >= 12 ) {
		$(".checkout-button-container input").attr("disabled", false);
	} else {
		$(".checkout-button-container input").attr("disabled", true);
	}*/

	if ( wholesale_product_total >= 1 ) {
		$(".checkout-button-container input").attr("disabled", false);
	} else {
		$(".checkout-button-container input").attr("disabled", true);
	}
}









function cartFormChangeHandler() {

	console.log( 'cartFormChangeHandler...' ) ;

	cart_total = 0 ;
	$('#cart-form .product-item').each(function(){
		var quantity = 0 ;
		var price = 0 ;
		var quantity_input = $( this ).find( '.quantity .product-form__input' ) ;
		if ( quantity_input.length > 0 ) quantity = quantity_input[ 0 ].value ;

		var money_span = $( this ).find( '.item-price .money' ) ;
		// convert to camelCase because the html5 data attribute is kinda dumb //
		if ( money_span.length > 0 ) price = money_span[ 0 ].dataset[ 'originalValue' ] ;
		var line_total = 0 ;
		if ( price && quantity ) line_total = price * quantity ;
		cart_total += line_total ;
		console.log( 'line_total: ' , line_total , ' Total: ' , cart_total ) ;
	});
	//console.log( 'Setting values to:' , cart_total ) ;
	// generate and apply the new html //
	var html_str = '<span id="the-subtotal-price" class="money" data-original-value="' + cart_total + '">' + cart_total + '</span>' ;
	$('#the-subtotal-price').replaceWith( html_str ) ;
	//$('#the-subtotal-price').fadeIn( 1000 ) ;
	$('#the-subtotal-price').hide().fadeIn('slow')
	requestCurrencyUpdate() ;
}






































// calls the event to trigger the currency converter to run //
function requestCurrencyUpdate() {
	// calls the event to trigger the currency converter to run, but has to happen outside of the context of this class, hence settimeout //
	setTimeout(function () {
		try {

			BOLD.common.eventEmitter.emit( "BOLD_CURRENCY_double_check" );
			console.log( 'The currency has been updated' ) ;

		} catch( error ) {
			console.log( error ) ;
		}


		// dispatch an event so it's easy for me to identify this has happened //
		var event = new CustomEvent( "CURRENCY_UPDATED", {detail: {} });
		window.dispatchEvent( event ) ;

	} , 50 ) ;
}































$(function() {
	// initialise the add to cart form
	$('[id*="CardAddToCartForm-"]').each(function() {
		var ajaxCart = new window.AjaxCart(
			$(this)
		);
	});

	// initialise the change event for the product size dropdown
	$("#AddToCartForm-product-template .product-form__variants").change(function()
	{
		selectedVariantDropdownHandler();
	});	
});






























/*
Product Detail page functionality
*/
function selectedVariantDropdownHandler() {
	var selectedOption = jQuery(".product-form__variants option:selected");
	if ( selectedOption.length > 0 ) {
		if (selectedOption.attr("data-size") !== null && selectedOption.attr("data-size").length > 0) {
			jQuery(".product-sizeDisplay strong").text(selectedOption.attr("data-size"));
		}

		if (selectedOption.attr("data-servings") !== null && selectedOption.attr("data-servings").length > 0) {
			$(".product-sizeDisplay strong").text(jQuery(".product-sizeDisplay strong").text() + " - " + selectedOption.attr("data-servings"));
		}

		$(".product-sale__price .money").attr("data-original-value", selectedOption.attr("data-option-price"));	

		if (selectedOption.attr("data-option-price-compare") !== null && selectedOption.attr("data-option-price-compare").length > 0) {
			jQuery(".product-single__price--compare .money").attr("data-original-value", selectedOption.attr("data-option-price-compare"));	
			jQuery(".product-compare-price-container").fadeIn(100);
		} else {
			jQuery(".product-compare-price-container").hide();
		}

		// update the bundles if needed
		_sm_BundledProductsPopulate(selectedOption.attr("data-product-id"));

		// remove cached currencies or the value won't update
		var i;
		var dataAttrsToDelete = [];
		var dataAttrs = $(".product-single__price .money").get(0).attributes;
		var dataAttrsLen = dataAttrs.length;

		// loop through attributes and make a list of those
		// that begin with 'data-' and then a 3 letter currency code
		for (i = 0; i < dataAttrsLen; i++) {
			if (/data\-[a-zA-Z]{3}$/.test(dataAttrs[i].name)) {
				dataAttrsToDelete.push(dataAttrs[i].name);
			}		
		}
		
		jQuery.each( dataAttrsToDelete, function( index, attrName ) {
			jQuery(".product-single__price .money").removeAttr( attrName );
		})

		// select the default image in the slider
		if ( jQuery('.product-for').find('.other-product-image-' + selectedOption.attr("data-product-id")).attr('data-slick-index') ) 
		{
			jQuery('.product-for').slick(
				'slickGoTo',
				jQuery('.product-for').find('.other-product-image-' + selectedOption.attr("data-product-id")).attr('data-slick-index'),
				true
			);
		} else  {
			jQuery('.product-for').slick(
				'slickGoTo',
				0,
				true
			);
		}

		requestCurrencyUpdate();
	}
}







/* 
Automatically select the product displayed on this page 
in any select dropdowns for any bundle options
*/
var bundle_autoselect_complete = false ;
function autoSelectCurrentProductWithinBundle(){
	// gather the necessary properties //
	 var product_title = $('meta[itemprop="name"]').attr('content') ;
	 var product_size = $('meta[itemprop="size"]').attr('content') ;
	// create a variable to match against the label used in the dropdown //
	var product_option_label = product_title + ' ' + product_size ;

	// create an array
	var ids_array = [ '#ProductSelect-bundle-first-product' , '#ProductSelect-bundle-second-product' ] ;
	for ( var i = 0 ; i < ids_array.length ; i++ ) {
		var curr_id = ids_array[ i ] ;
		// loop through the options in the first product to find the option which matches the product on this page, then select it //
		var first_product = $( curr_id ) ;
		if ( first_product.length > 0 ) {
			$( curr_id + ' option' ).each(function( index ) {
				var lowercase_curr_label = $( this ).text().toLowerCase()
				var lowercase_product_option_label = product_option_label.toLowerCase()
				if ( lowercase_curr_label == lowercase_product_option_label ) $( curr_id ).val( this.value ) ; 
			});
		}
	}
	// ensure we only do this once //
	bundle_autoselect_complete = true ;
}




function _sm_BundleProductsPricingChangeHandler() {
  	// get the selected indecies and add 1 to them so they'll work in the nth-child selectors //
  	var product_1_selected_index = document.getElementById("ProductSelect-bundle-first-product").selectedIndex + 1 ;
  	var product_2_selected_index = document.getElementById("ProductSelect-bundle-second-product").selectedIndex + 1;

  	// get the price of the items //
	var product_1_price = Number( document.querySelector("#ProductSelect-bundle-first-product option:nth-child(" + product_1_selected_index + ")" ).dataset.price ) ;
	var product_2_price = Number( document.querySelector("#ProductSelect-bundle-second-product option:nth-child(" + product_2_selected_index + ")" ).dataset.price ) ;

  	//console.log( 'The selector has changed > selected indecies are: ' + product_1_selected_index + ' and ' + product_2_selected_index ) ;
  	//console.log( 'Their prices are: ' + product_1_price/100 + ' and ' + product_2_price/100 ) ;
  	var quantity = parseInt($("#Bundle-Quantity").val());
  	var total = ( product_1_price + product_2_price ) * quantity ; 
  	var total_as_decimal = ( total / 100 ) ;
  		total_as_decimal = total_as_decimal.toFixed(2)
  	//console.log( product_1_price , product_2_price , quantity , total , total_as_decimal ) ;

  	// display the total price
  	document.getElementById( 'total-bundle-price' ).outerHTML = '<span id="total-bundle-price">...</span>' ;
  	document.getElementById( 'total-bundle-price' ).outerHTML = '<span id="total-bundle-price" class="money">' + total_as_decimal + '</span>' ;

	setTimeout(function () {
		//if ( LOGGING.PRICING ) console.log ("doing currency update")
		try {
			BOLD.common.eventEmitter.emit( "BOLD_CURRENCY_double_check" );
		} catch( error ) {
			console.log( error ) ;
		}
	} , 50 ) ;
}










 // bind the product dropdowns based on the given product Id
 function _sm_BundledProductsPopulate( productId ) {

	$.each( window._sm_bundledProducts , function ( i , bundleProduct ) {

	  if ( bundleProduct.id == productId ) {

		$( "#ProductSelect-bundle-first-product option" ).remove() ;
		$( "#ProductSelect-bundle-second-product option" ).remove() ;

		$.each( bundleProduct.products , function ( i , product ) {
		  $( "#ProductSelect-bundle-first-product" ).append( '<option value="' + product.id + '" data-price="' + product.price + '">' + product.title + ' ' + product.size + '</option>' ) ;
		  $( "#ProductSelect-bundle-second-product" ).append( '<option value="' + product.id + '" data-price="' + product.price + '">' + product.title + ' ' + product.size + '</option>' ) ;
		});

	  }
	});

	// autoselect the current product within bundles if this is the first time through //
	if ( !bundle_autoselect_complete ) {
		autoSelectCurrentProductWithinBundle() ;
		// trigger a change so the price updates too //
		setTimeout( function(){
			$('#multi-variant-add').trigger( 'change' ) ;
		} , 2000 ) ;
	}

  }





  $(function() {
	if ( typeof window._sm_bundledProducts !== 'undefined' && window._sm_bundledProducts !== null && window._sm_bundledProducts.length > 0 ) {


	  // setting up a default product to start with //
	  // we'll check if the first product has child products, if it does that'll be our default product //
	  // if the first product doesn't have child products, we'll look at the second //
	  // if that has child products, we'll make that the default instead //
	  // if neither has products, we just won't show the bundles at all //
	  var product_to_start_with ;
	  var display_bundle_selectors = false ;
	  var display_first_bundle_selector = false ;
	  var display_second_bundle_selector = false ;

	  console.log( 'Bundle Products: ' , window._sm_bundledProducts , window._sm_bundledProducts.length ) ;	  

	  // check which selectors we should show //
	  if ( _sm_bundledProducts[ 0 ].products.length > 0 ) display_first_bundle_selector = true ;
	  // there may not be a product at [1] //
	  try {
	  	if ( _sm_bundledProducts[ 1 ].products.length > 0 ) display_second_bundle_selector = true ;
	  } catch( err ) {  };

	  // if we should display either selector, we should display the form //
	  if ( display_first_bundle_selector || display_second_bundle_selector ) display_bundle_selectors = true ;


	  // start with the first available product selector selected //
	  if ( display_first_bundle_selector ) {
	  	//console.log( 'The first product has products...' ) ;
	  	product_to_start_with = _sm_bundledProducts[ 0 ].id ;
	  } else if ( display_second_bundle_selector ) {
	  	//console.log( 'The first product DOES NOT HAVE PRODUCTS...' ) ;
	  	product_to_start_with = _sm_bundledProducts[ 1 ].id ;
	  }


	  console.log( 'display_bundle_selectors: ' , display_bundle_selectors ) ;
	  //if ( display_bundle_selectors ) {
		  console.log( 'product_to_start_with: ' , product_to_start_with ) ;
		  console.log( 'display_first_bundle_selector: ' , display_first_bundle_selector ) ;
		  console.log( 'display_second_bundle_selector: ' , display_second_bundle_selector ) ;
	  //}





	  // only display if we have at least one valid selection to use //
	  if ( display_bundle_selectors ) {

	  	  var sizes_select = document.getElementById( 'ProductSelect-product-template' ) ;
	  	  if ( sizes_select ) {
	  	  	var disabled_color = '#ddd' ;
	  	  	var disabled_str = '(unavailable)' ;
		  	  // hide first size selector if it's a no show //
		  	  if ( !display_first_bundle_selector ) {
		  	  	sizes_select.children[ 0 ].disabled = true ;
		  	  	sizes_select.children[ 0 ].style.color = disabled_color ;
		  	  	sizes_select.children[ 0 ].textContent = sizes_select.children[ 0 ].textContent + disabled_str ;
		  	  }
		  	  // hide second size selector if it's a no show, and if the second size selector option exists //
			  try { 
			  	if ( !display_second_bundle_selector && sizes_select.children[ 1 ] ) {
			  		sizes_select.children[ 1 ].disabled = true ; 
			  		sizes_select.children[ 1 ].style.color = disabled_color ;
			  		sizes_select.children[ 1 ].textContent = sizes_select.children[ 1 ].textContent + disabled_str ;
			  	}
			  } catch( err ) { } ;
	  	  }

	  	  console.log( 'sizes_select: ' , sizes_select ) ;


		  // Use product_to_start_with as the default product //
		  _sm_BundledProductsPopulate( product_to_start_with ) ;
          var currentDate = new Date();
          var startDate = Date.UTC(2023, 8, 4, 2, 0, 0);
          var endDate = Date.UTC(2023, 8, 10, 5, 0, 0);
          var currentUtcDate = Date.UTC(currentDate.getUTCFullYear(), currentDate.getUTCMonth(), currentDate.getUTCDate(), currentDate.getUTCHours(), currentDate.getUTCMinutes(), currentDate.getUTCSeconds());
          if (!((startDate < currentUtcDate) && (endDate > currentUtcDate))) {       
    		  $( ".bundle-container" ).fadeIn( 300 ) ;
          }

		  if ( document.querySelector( 'body.bundle-product') ) {

			  $('#multi-variant-add').change( _sm_BundleProductsPricingChangeHandler ) ;
			  $('#product__bundle-container').change( _sm_BundleProductsPricingChangeHandler ) ;
			  var quantity_container = $( '#Bundle-Quantity' ).parent().parent() ;
			      quantity_container.click( _sm_BundleProductsPricingChangeHandler ) ;
			      quantity_container.change( _sm_BundleProductsPricingChangeHandler ) ;

		  }


		  // handler to add the products to the cart
		  $( '#multi-variant-add' ).submit( function( event ) {

			event.preventDefault() ;

			var id = parseInt( $( "#ProductSelect-bundle-first-product" ).val() ) ;
			var quantity = parseInt( $( "#Bundle-Quantity" ).val() ) ;      

			var params = {
			  type: 'POST',
			  url: '/cart/add.js',
			  data: { "quantity": quantity, "id": id },
			  dataType: 'json',
			  success:function( lineItem ) {

				var id = parseInt( $( "#ProductSelect-bundle-second-product" ).val() ) ;
				params.data = { "quantity" : quantity , "id": id }
				params.success = function( lineItem ) {

					if ( AjaxCart ) {
						console.log( 'THE LINE ITEM IS....' ) ;
						console.log( lineItem ) ;
						window.AjaxCart.prototype.success( lineItem ) ;
					} else {

					  shappify_pb_main(function(){ 
		        	    console.log( 'Updated cart, so updating bold bundles.' ) ;
				        var event = new CustomEvent( 'CART_UPDATED' , { detail: {} } ) ;
				        window.dispatchEvent( event ) ;
		      		  }) ;

					  theme.Notify.open( 'success' , false , true ) ;

					}

				};

				$.ajax( params ) ;

			  },
			  error: function( XMLHttpRequest , textStatus ) {
				var data = JSON.parse(XMLHttpRequest.responseText);

				if ( data.message ) {
				  theme.Notify.open( 'error' , data.description , true ) ;
				}              
			  }
			};

			$.ajax( params ) ;
										
		  }) ;

	  }


	}
  });








































/* functions related to the custom products filter */
function initCustomProductsFilter(){

    if ($('#custom-products-filter').length == 0) {
      // no product filters on this page
      return;
    }

	var multiple = $('#custom-products-filter')[0].classList.contains('allow-multiple' ) ;

	if( multiple ){
		$('#custom-products-filter .options a').click(function(event){
			event.preventDefault();
			selectCustomProductFilterOption( this , multiple ) ;
			var selections = getCustomProductFilterSelections() ;
			if ( selections.length > 0 ) {
				$('#custom-products-filter .btn')[0].classList.remove('unavailable');
			} else {
				$('#custom-products-filter .btn')[0].classList.add('unavailable');
			}
		});		
	}


	if ( multiple ) {
		$('#custom-products-filter .btn').click(function(event){
			event.preventDefault();
			var tags = getCustomProductFilterSelections() ;
			if ( tags.length > 0 ) {
				var target_url = $( '#custom-products-filter' )[0].dataset.url + tags.join('+') ;
				console.log( 'target_url: ' , target_url ) ;
				window.location.href = target_url ;
			}
		});		
	}


}


function selectCustomProductFilterOption( item , multiple_allowed ) {
	if ( multiple_allowed ) {
		item.classList.toggle( 'selected' ) ;
	} else {
		$('#custom-products-filter .options a').each(function(){
			this.classList.remove( 'selected' ) ;
		});
		item.classList.add( 'selected' ) ;
	}
}


function getCustomProductFilterSelections(){
	var tags = [] ;
	$('#custom-products-filter .options a').each(function(){
		if ( this.classList.contains( 'selected' ) ) {
			var tag = this.dataset.tag ;
			tags.push( tag ) ;
		}
	});
	return tags ;
}



